<article class="widget-block">
	<div class="widget-block__header">
		<app-round-icon
			class="widget-block__image-wrapper"
			[imageData]="widgetIcon"
		></app-round-icon>
		<h2 class="widget-block__title">{{ this.widgetTitle }}</h2>
	</div>
	<div class="widget-block__tab-selector">
		@if (tabsControl) {
			<app-tabs-field [customFormControl]="tabsControl"></app-tabs-field>
		}
	</div>

	<div class="widget-block__tabs-wrapper">
		@if (tabsControl.value === 'tab1') {
			<section class="widget-block__tab1">
				@if (subscriptionsAbsence) {
					<section class="widget-block__add-block">
						<p class="widget-block__add-text">
							Добавьте подписку на&nbsp;информирование о&nbsp;новых начислениях
						</p>
						<button
							class="button widget-block__add-button"
							(click)="addSubscription()"
						>
							Добавить
						</button>
					</section>
				} @else {
					@if (this.charges.length) {
						<app-charge-list [items]="this.charges"></app-charge-list>
					} @else {
						<p class="widget-block__tab-title">
							Нет новых начислений по&nbsp;подписке. Вы&nbsp;можете найти&nbsp;их,
							воспользовавшись
							<button
								class="button-text widget-block__add-link"
								(click)="toSearch()"
								type="button"
							>
								поиском
							</button>
						</p>
					}
				}
			</section>
		}
		@if (tabsControl.value === 'tab2') {
			<section class="widget-block__tab2">
				<ng-content></ng-content>
				<div class="widget-block__round-loader">
					@if (pending) {
						<app-round-loader></app-round-loader>
					}
				</div>
				<app-charge-list
					[items]="this.charges"
					[onSearchTab]="true"
					[searchDocNumber]="searchDocNumber"
					[errors]="this.searcErrors"
				></app-charge-list>
			</section>
		}
	</div>
</article>
